<div class="min-h-screen bg-gray-50 flex flex-col">
    <app-navbar />

    <div class="flex flex-1 pt-16">
        <app-sidebar />

        <main class="flex-1 transition-all duration-300 ml-0 p-4 md:p-8"
            [ngClass]="{ 'md:ml-20': layoutService.isDesktopSidebarCollapsed(), 'md:ml-64': !layoutService.isDesktopSidebarCollapsed() }">
            <div class="max-w-8xl mx-auto">
                <router-outlet />
            </div>
        </main>
    </div>
</div>